module.exports = __webpack_public_path__ + "img/karta-mundurowa.eb11b87d.svg";